import { useRouteError } from 'react-router';
import { Loader2, RefreshCw, TriangleAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { isStaleBuildError, reloadForNewBuild } from '@/lib/stale-build';

/** Erro de rota: versão nova publicada (recarrega sozinho) ou falha inesperada (tela amigável). */
export function RouteError() {
  const error = useRouteError();
  const stale = isStaleBuildError(error);
  const reloading = stale && reloadForNewBuild();
  return (
    <main className="flex min-h-svh items-center justify-center p-6">
      <div className="max-w-md space-y-4 text-center" role="alert">
        {reloading ? (
          <>
            <Loader2 className="text-muted-foreground mx-auto size-8 animate-spin" aria-hidden />
            <p className="text-lg font-medium">Atualizando para a versão mais recente…</p>
          </>
        ) : (
          <>
            <TriangleAlert className="text-warning mx-auto size-8" aria-hidden />
            <h1 className="text-lg font-semibold">{stale ? 'Uma nova versão do Orienta foi publicada' : 'Algo deu errado nesta página'}</h1>
            <p className="text-muted-foreground text-sm">
              {stale ? 'Recarregue a página para continuar.' : 'Tente recarregar. Se o problema continuar, avise a administração da plataforma.'}
            </p>
            <div className="flex justify-center gap-2">
              <Button onClick={() => window.location.reload()}>
                <RefreshCw /> Recarregar
              </Button>
              <Button variant="outline" onClick={() => window.location.assign('/')}>
                Ir para o início
              </Button>
            </div>
          </>
        )}
      </div>
    </main>
  );
}
